export function productSourceId(product) {
  return Number(product?.produto_id ?? product?.id ?? 0) || null;
}

export function normalizeOperationalBoolean(value, fallback = false) {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }
  if (typeof value === "boolean") {
    return value;
  }
  if (typeof value === "number") {
    return value !== 0;
  }

  const normalized = String(value).trim().toLocaleLowerCase("pt-BR");
  if (
    ["0", "false", "nao", "não", "no", "off", "inativo", "pausado"].includes(
      normalized
    )
  ) {
    return false;
  }
  if (
    [
      "1",
      "true",
      "sim",
      "yes",
      "on",
      "ativo",
      "disponivel",
      "disponível",
    ].includes(normalized)
  ) {
    return true;
  }

  return fallback;
}

export function normalizeOperationalProduct(product) {
  const sourceId = productSourceId(product);
  const groups = product?.grupos_opcoes || product?.opcoes || [];
  const pizza = product?.pizza || null;
  const priceCents = Number(
    product?.preco_base_centavos ??
      product?.preco_centavos ??
      Math.round(Number(product?.preco || 0) * 100)
  );

  return {
    ...product,
    id: sourceId,
    produto_id: sourceId,
    cardapio_produto_id: product?.cardapio_produto_id || null,
    descricao: product?.nome || product?.descricao || "Produto",
    preco: priceCents / 100,
    preco_centavos: priceCents,
    imagem: product?.imagem_url || product?.imagem || null,
    grupo: product?.grupo || null,
    grupo_id: product?.grupo_id ?? product?.id_grupo ?? product?.grupo?.id ?? 0,
    grupo_nome:
      product?.grupo_nome ||
      product?.grupo?.nome ||
      product?.categoria_nome ||
      "Outros",
    pizza,
    grupos_opcoes: Array.isArray(groups) ? groups : [],
    configuravel:
      normalizeOperationalBoolean(product?.configuravel) ||
      normalizeOperationalBoolean(product?.possui_opcoes) ||
      normalizeOperationalBoolean(product?.requer_configuracao) ||
      Boolean(pizza) ||
      Boolean(Array.isArray(groups) && groups.length),
    restaurante_destinos: Array.isArray(
      product?.restaurante_destinos || product?.destinos
    )
      ? product.restaurante_destinos || product.destinos
      : [],
  };
}

export function normalizeOperationalCatalog(payload) {
  const value = payload?.data ?? payload ?? [];
  const grouped = Array.isArray(value)
    ? value
    : value?.grupos || value?.categorias || null;

  if (
    Array.isArray(grouped) &&
    grouped.some((group) => Array.isArray(group?.produtos || group?.items))
  ) {
    return grouped.map((group) => ({
      id: Number(group.id ?? group.grupo_id ?? 0),
      nome: group.nome || group.name || "Outros",
      produtos: (group.produtos || group.items || []).map(
        normalizeOperationalProduct
      ),
    }));
  }

  const products = Array.isArray(value)
    ? value
    : value?.produtos || value?.items || value?.data || [];
  const groupsById = new Map();

  (Array.isArray(products) ? products : []).forEach((rawProduct) => {
    const product = normalizeOperationalProduct(rawProduct);
    const groupId = Number(product.grupo_id || 0);

    if (!groupsById.has(groupId)) {
      groupsById.set(groupId, {
        id: groupId,
        nome: product.grupo_nome || "Outros",
        produtos: [],
      });
    }

    groupsById.get(groupId).produtos.push(product);
  });

  return Array.from(groupsById.values()).sort((left, right) =>
    left.nome.localeCompare(right.nome, "pt-BR")
  );
}

export function hasStructuredConfiguration(payload) {
  return Boolean(
    payload?.pizza ||
      (Array.isArray(payload?.adicionais) && payload.adicionais.length)
  );
}
